import type { RefObject } from "react";
import type { FieldPath, FieldValues, UseFormReturn } from "react-hook-form";

export const markServerErrorsAndScroll = <T extends FieldValues, K extends HTMLElement = HTMLElement>(
  form: UseFormReturn<T>,
  fieldNames: string[],
  formRef?: RefObject<K | null>
) => {
  const eligibleFieldsInDOM = fieldNames.filter((fieldName) => {
    const selector = `[name="${fieldName}"], [id="${fieldName}"]`;
    const el = formRef?.current?.querySelector(selector) as HTMLElement | null;
    return el && !el.hasAttribute("disabled");
  });

  for (const fieldName of eligibleFieldsInDOM) {
    form.setError(fieldName as FieldPath<T>, { type: "server", message: "" });
  }

  requestAnimationFrame(() => {
    const firstErrorWrapper = formRef?.current?.querySelector('[class*="wrapperError"], [class*="hasEmptyError"]');
    if (firstErrorWrapper) {
      firstErrorWrapper.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  });
};
